import { apiClient } from '@/api/client'
import type {
  MicrogridListItem,
  MicrogridCreateFields,
  MicrogridUpdateFields,
  MicrogridSharingControllersResponse,
} from './types'

export async function fetchMicrogrids(): Promise<MicrogridListItem[]> {
  const { data } = await apiClient.get<MicrogridListItem[]>('/portal/controllers/api/v2/microgrids')
  return data
}

/** The microgrid linked to one controller (or null), for the Microgrid
 * section on the controller edit page. */
export async function fetchMicrogridForController(controllerId: string): Promise<MicrogridListItem | null> {
  const { data } = await apiClient.get<MicrogridListItem | null>(
    `/portal/controllers/api/v2/${controllerId}/microgrid`,
  )
  return data
}

export async function createMicrogrid(fields: MicrogridCreateFields): Promise<MicrogridListItem> {
  const { data } = await apiClient.post<MicrogridListItem>('/portal/controllers/api/v2/microgrids', fields)
  return data
}

/** Only display_name is editable -- microgrid_id (the primary key) and
 * controller_id (unique per microgrid) are immutable once created; remove
 * and re-add to change either. */
export async function updateMicrogrid(microgridId: string, fields: MicrogridUpdateFields): Promise<MicrogridListItem> {
  const { data } = await apiClient.patch<MicrogridListItem>(
    `/portal/controllers/api/v2/microgrids/${microgridId}`,
    fields,
  )
  return data
}

export async function deleteMicrogrid(microgridId: string): Promise<void> {
  await apiClient.delete(`/portal/controllers/api/v2/microgrids/${microgridId}`)
}

/** Every controller some device has reported this microgrid_id under
 * recently -- not just the `microgrids` table's single registered owner
 * (see the backend route's docstring for why a legacy self-resolved
 * controller needs this separate lookup instead of appearing in
 * MicrogridListItem alone). Includes device_ids that don't resolve to any
 * controller yet. */
export async function fetchMicrogridSharingControllers(
  microgridId: string,
): Promise<MicrogridSharingControllersResponse> {
  const { data } = await apiClient.get<MicrogridSharingControllersResponse>(
    `/portal/controllers/api/v2/microgrids/${microgridId}/controllers`,
  )
  return data
}
